export default new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    minimumFractionDigits: 4,
});;


// WEBPACK FOOTER //
// ./src/util/money-formatter.js